import { m } from 'framer-motion'
import { styled } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'
import { Button, Box, Container, Typography, Grid, Card } from '@mui/material'
import Image from '../../components/image'
import useResponsive from '../../hooks/useResponsive'
import { PATH_PAGE } from '../../routes/paths'
import Iconify from '../../components/iconify'

import { AWS_CDN_DOMAIN } from 'src/config-global'

const backgroundImageOne = '/assets/svg/tall-frame.svg'

const StyledRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(15, 0),
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    height: '10px',
    backgroundColor: '#fff',
  },
}))

const StyledImageRoot = styled(m.div)(({ theme }) => ({
  position: 'relative',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundImage: `url(${backgroundImageOne})`,
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up('md')]: {
    height: 540,
    width: 440,
    padding: 0,
  },
}))

// ----------------------------------------------------------------------
const items = [
  {
    id: 1,
    text: 'End-to-end cargo visibility',
  },
  {
    id: 2,
    text: 'Tailored to your needs and budget',
  },
  {
    id: 3,
    text: 'Complete shipment solutions united under one provider',
  },
]
export default function HomeConfidence() {
  const isDesktop = useResponsive('up', 'md')

  const renderItem = (item) => {
    return (
      <Grid container spacing={3} sx={{ mt: 10, maxWidth: 1000 }} key={item.id}>
        {isDesktop && (
          <Grid md={2} sm={2} lg={2} xl={2}>
            <Iconify
              icon="clarity:dot-circle-line"
              width={30}
              sx={{
                color: 'common.black',
                transition: 'color 0.3s ease-in-out',
                ml: 3,
                mt: 1.2,
              }}
              onMouseEnter={(e) => (e.target.style.color = '#000')}
              onMouseLeave={(e) => (e.target.style.color = '#000')}
            />
          </Grid>
        )}

        <Grid md={10} sm={10} lg={10} xl={10}>
          <Typography
            variant="body2"
            sx={{
              textAlign: 'left',
              fontWeight: 30,
              fontSize: 30,
              color: 'text.primary',
            }}
          >
            {item.text}
          </Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <StyledRoot>
      <Container>
        <Box
          gap={{ xs: 3, lg: 5 }}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
            justifyContent: 'left',
            textAlign: 'left',
            color: 'common.white',
            maxWidth: 'auto',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              textAlign: 'left',
              maxWidth: 1000,
              color: 'common.black', // Change text color to black
              lineHeight: '1.1em',
              fontWeight: 50,
              letterSpacing: '-0.04em',
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif', // Use Apple system font
            }}
          >
            Ship With Confidence
          </Typography>
          <div>
            <Button
              variant="contained"
              component={RouterLink}
              to={PATH_PAGE.contact}
              sx={{
                borderRadius: '999px',
                padding: '12px 32px',
              }}
            >
              Ship With Cubistics
            </Button>
          </div>
          <Grid container spacing={3}>
            {/* Mobile responsive Grids */}
            <Grid md={6} sm={12} lg={6} xl={6}>
              <Card sx={{ p: 3, m: 3, borderRadius: 2, boxShadow: 0 }}>{items.map((item) => renderItem(item))}</Card>
            </Grid>
            <Grid md={6} sm={12} lg={6} xl={6}>
              {/* Display Styled Image Root and Image Element */}
              {isDesktop && (
                <StyledImageRoot>
                  <Grid item xs={12} md={6} lg={7} sx={{ pr: { md: 7 } }}>
                    <Grid container spacing={3} alignItems="flex-end">
                      <Grid item xs={6}>
                        <Image
                          alt="Ship with Confidence"
                          src={AWS_CDN_DOMAIN + '/frontend-files/shipwithconfidence.webp'}
                          sx={{
                            borderRadius: 0,
                            height: 440,
                            width: 540,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </StyledImageRoot>
              )}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </StyledRoot>
  )
}
